import DashboardLayout from "../../layouts/DashboardLayout";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
import { useEffect, useState } from "react";
import { getDoc } from "firebase/firestore";
import "./Subscription.css";
import { useNavigate } from "react-router-dom";
import { saveInvoice } from "../../services/invoiceService";
import { generateInvoice } from "../../utils/generateInvoice";
import { getPlans } from "../../services/subscriptionService";
import { useAuth } from "../../context/AuthContext";

function PlanCard({ title, plans, selected, setSelected, onSubscribe }) {
  if (!selected) return null;

  return (
    <div className={`plan-card ${title === "Premium" ? "featured-plan" : ""}`}>
      {title === "Premium" && <div className="featured-tag">Most Popular</div>}

      <h2>{title}</h2>

      <div className="radio-group">
        {plans.map((plan) => (
          <label
            key={plan.id}
            className={`duration-option ${
              selected.id === plan.id ? "active" : ""
            }`}
          >
            <input
              type="radio"
              name={title}
              checked={selected.id === plan.id}
              onChange={() => setSelected(plan)}
            />

            <div className="duration-info">
              <span className="duration-title">{plan.duration}</span>

              <span className="duration-price">
                ₹{Number(plan.price).toLocaleString("en-IN")}
              </span>
            </div>
          </label>
        ))}
      </div>

      <div className="price-section">
        <span className="currency">₹</span>
        <span className="price">
          {Number(selected.price).toLocaleString("en-IN")}
        </span>
      </div>

      <ul className="features-list">
        <li>✓ {selected.duration}</li>

        <li>✓ {selected.features?.memberLimit} Members</li>

        <li>✓ {selected.features?.trainerLimit} Trainers</li>

        <li>✓ {selected.features?.storageLimit} MB Storage</li>

        {selected.features?.attendance && <li>✓ Attendance</li>}

        {selected.features?.membershipPlans && <li>✓ Membership</li>}

        {selected.features?.payments && <li>✓ Payments</li>}

        {selected.features?.trainers && <li>✓ Trainers</li>}

        {selected.features?.reports && <li>✓ Reports</li>}

        {selected.features?.qrScanner && <li>✓ QR Check-In</li>}

        {selected.features?.memberPortal && <li>✓ Member Portal</li>}

        {selected.features?.dietPlan && <li>✓ Diet Plans</li>}

        {selected.features?.aiWorkout && <li>✓ Workout Plans</li>}

        {selected.features?.customerSupport && <li>✓ Customer Support</li>}
      </ul>

      <button
        className="subscription-btn"
        onClick={() => onSubscribe(selected)}
      >
        Subscribe Now
      </button>
    </div>
  );
}

export default function Subscription() {
  const navigate = useNavigate();
  const { currentUser, loading } = useAuth();

  const [gym, setGym] = useState(null);
  const [plans, setPlans] = useState([]);

  const [selectedPlans, setSelectedPlans] = useState({
    Basic: null,
    Standard: null,
    Premium: null,
  });
  const groupedPlans = {
    Basic: plans.filter((p) => p.planName === "Basic"),
    Standard: plans.filter((p) => p.planName === "Standard"),
    Premium: plans.filter((p) => p.planName === "Premium"),
  };

  useEffect(() => {
    if (loading) return;

    if (!currentUser) {
      navigate("/login");
      return;
    }

    const loadGym = async () => {
      const snap = await getDoc(doc(db, "gyms", currentUser.uid));

      if (!snap.exists()) return;

      const gymData = snap.data();
      setGym(gymData);

      const planData = await getPlans();
      setPlans(planData);

      setSelectedPlans({
        Basic: planData.find(
          (p) => p.planName === "Basic" && p.duration === "1 Month",
        ),
        Standard: planData.find(
          (p) => p.planName === "Standard" && p.duration === "1 Month",
        ),
        Premium: planData.find(
          (p) => p.planName === "Premium" && p.duration === "1 Month",
        ),
      });

      if (
        gymData.subscriptionStatus === "Active" &&
        gymData.subscriptionEndDate
      ) {
        navigate("/dashboard");
      }
    };

    loadGym();
  }, [currentUser, loading, navigate]);

  const handlePayment = (plan) => {
    const options = {
      key: "rzp_test_SzS8RQMs1ieG35",

      // amount: plan.amount * 100,
      amount: plan.price * 100,

      currency: "INR",

      name: "NN AI Gym SaaS",

      // description: `${plan.name} Subscription`,
      description: `${plan.planName} - ${plan.duration} Subscription`,

      handler: async function (response) {
        const today = new Date();
        const expiry = new Date();

        console.log("Selected Plan:", plan);
        console.log("Plan ID:", plan.id);
        console.log("Plan Name:", plan.planName);
        console.log("Duration:", plan.duration);
        console.log("Months:", plan.months, typeof plan.months);

        expiry.setMonth(today.getMonth() + Number(plan.months));

        console.log("Today:", today);
        console.log("Expiry:", expiry);
        console.log("Expiry Valid:", !isNaN(expiry.getTime()));
        // await updateDoc(doc(db, "gyms", auth.currentUser.uid), {
        await updateDoc(doc(db, "gyms", currentUser.uid), {
          paymentDone: true,
          paymentStatus: "Paid",
          paymentId: response.razorpay_payment_id,

          // subscriptionPlan: plan.name,
          subscriptionStatus: "Active",
          subscriptionPlan: plan.planName,
          subscriptionPlanId: plan.id,
          subscriptionDuration: plan.duration,
          subscriptionMonths: plan.months,
          subscriptionPrice: plan.price,

          subscriptionStartDate: today.toISOString().split("T")[0],
          subscriptionEndDate: expiry.toISOString().split("T")[0],

          // features: PLAN_FEATURES[plan.name],
          features: plan.features,

          // memberLimit: PLAN_FEATURES[plan.name].memberLimit,
          memberLimit: plan.features.memberLimit,
          trainerLimit: plan.features.trainerLimit,
          storageLimit: plan.features.storageLimit,
          storageUsed: 0,
        });

        await saveInvoice({
          invoiceNo: `INV-${Date.now()}`,

          // gymId: auth.currentUser.uid,
          gymId: currentUser.uid,

          gymName: gym?.gymName || "",

          ownerName: gym?.ownerName || "",

          email: gym?.email || "",

          phone: gym?.phone || "",

          // plan: plan.name,

          // amount: plan.amount,
          plan: `${plan.planName} (${plan.duration})`,

          amount: plan.price,

          paymentId: response.razorpay_payment_id,

          paymentStatus: "Paid",

          subscriptionStartDate: today.toISOString().split("T")[0],

          subscriptionEndDate: expiry.toISOString().split("T")[0],

          createdAt: new Date(),
        });

        generateInvoice({
          invoiceNo: `INV-${Date.now()}`,

          gymName: gym.gymName,

          ownerName: gym.ownerName,

          email: gym.email,

          phone: gym.phone,

          // plan: plan.name,

          // amount: plan.amount,
          plan: `${plan.planName} (${plan.duration})`,

          amount: plan.price,

          paymentStatus: "Paid",

          paymentId: response.razorpay_payment_id,

          subscriptionStartDate: today.toISOString().split("T")[0],

          subscriptionEndDate: expiry.toISOString().split("T")[0],
        });

        alert("Payment Successful");

        navigate("/dashboard");
      },

      theme: {
        color: "#4f46e5",
      },
    };

    const razorpay = new window.Razorpay(options);

    razorpay.open();
  };

  return (
    <DashboardLayout>
      <div className="subscription-page">
        <div className="subscription-header">
          <span className="subscription-badge">NN FIT Subscription</span>

          <h1>Choose Your Perfect Plan</h1>

          <p style={{ fontWeight: "bold", color: "white" }}>
            Unlock all gym management features, manage members, trainers,
            attendance, payments, reports and grow your fitness business.
          </p>
        </div>
        {gym && (
          <div className="current-plan-card">
            <h2>Current Subscription</h2>

            <p>
              <strong>Registration Type:</strong>{" "}
              {gym.registrationType === "trial" ? " Free Trial" : " Paid"}
            </p>

            <p>
              <strong>Current Plan:</strong>{" "}
              {gym.subscriptionPlan || "No Active Plan"}
            </p>

            <p>
              <strong>Status:</strong> {gym.subscriptionStatus}
            </p>

            {gym.subscriptionEndDate && (
              <p>
                <strong>Expiry:</strong> {gym.subscriptionEndDate}
              </p>
            )}
          </div>
        )}

        <div className="plans-grid">
          <PlanCard
            title="Basic"
            plans={groupedPlans.Basic}
            selected={selectedPlans.Basic}
            setSelected={(plan) =>
              setSelectedPlans((prev) => ({
                ...prev,
                Basic: plan,
              }))
            }
            onSubscribe={handlePayment}
          />

          <PlanCard
            title="Standard"
            plans={groupedPlans.Standard}
            selected={selectedPlans.Standard}
            setSelected={(plan) =>
              setSelectedPlans((prev) => ({
                ...prev,
                Standard: plan,
              }))
            }
            onSubscribe={handlePayment}
          />

          <PlanCard
            title="Premium"
            plans={groupedPlans.Premium}
            selected={selectedPlans.Premium}
            setSelected={(plan) =>
              setSelectedPlans((prev) => ({
                ...prev,
                Premium: plan,
              }))
            }
            onSubscribe={handlePayment}
          />
        </div>
      </div>
    </DashboardLayout>
  );
}
